import React, { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import axiosInstance from '@/lib/axios';
import { cn } from '@/lib/utils';

// interface Department {
//   _id?: string;
//   id?: string;
//   name: string;
//   isActive?: boolean;
// }

interface DepartmentDropdownProps {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
  departments?: Array<{ _id?: string, id?: string, name: string }>;
  disabled?: boolean;
  placeholder?: string;
}

const DepartmentDropdown: React.FC<DepartmentDropdownProps> = ({ value, onValueChange, className, departments: departmentsFromProps, disabled = false, placeholder }) => {
  const [departments, setDepartments] = useState<any[]>(departmentsFromProps || []);

  useEffect(() => {
    if (departmentsFromProps) {
      setDepartments(departmentsFromProps);
      return;
    }

    const fetchDepartments = async () => {
      try {
        const response = await axiosInstance.get('/departments');
        const departmentsData = response.data.data || (Array.isArray(response.data) ? response.data : []);
        setDepartments(departmentsData);
      } catch (error: any) {
        if (error.response && error.response.status === 403) {
        } else {
          console.error('Error fetching departments:', error);
        }
      }
    };
    fetchDepartments();
  }, [departmentsFromProps]);



  // Always render dropdown even if departments end up empty due to permissions

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        className={cn(
          'h-10 rounded-lg border-gray-200 focus:border-blue-500 focus:ring-blue-500 text-sm w-full bg-white',
          className
        )}
        disabled={disabled}
      >
        <SelectValue placeholder={placeholder || "Select Department"} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="All">Select Department</SelectItem>
        {departments.map((department) => (
          <SelectItem key={department.id || department._id} value={department.id || department._id || department.name}>
            {department.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default DepartmentDropdown; 	